// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1fA54","inputWrap":"Table_inputWrap__2dSJ-","col":"Table_col__3TYkh","bmiTooltip":"Table_bmiTooltip__1O0W4"};